import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-actividad-noautocal',
  templateUrl: './actividad-noautocal.component.html',
  styleUrls: ['./actividad-noautocal.component.scss'],
})
export class ActividadNoautocalComponent implements OnInit {
  @Input() public curso: any;
  constructor() { }

  ngOnInit() {}

}
